var pos = {
    setPos: function () {
        var _this = this;
        $(function () {
            //获取定位参数
            var posName = common.getUrlPara('pos');
            var tabPosName = common.getUrlPara('tabpos');

            if (!posName) {
                return;
            }

            // 不使用滚动条的记录
            if ('scrollRestoration' in history) {
                // 默认值为'auto'
                history.scrollRestoration = 'manual';
            }

            //获取定位坐标
            setTimeout(function () {
                clickTab();
            }, 1000);

            function clickTab() {
                // var fixedPos = document.querySelector('.topbar').clientHeight * 2;

                if (posName) {
                    var $posClass = document.querySelector('.' + posName);
                    var $posId = document.querySelector('#' + posName);
                    var $pos = $posClass || $posId;
                    if(!$pos){
                        return;
                    }

                    var rect = $pos.getBoundingClientRect();
                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    var posNum = rect.top + scrollTop;
                    posNum = posNum - _this.getFix();
                    $('html, body').animate({ scrollTop: posNum }, 800)
                }

                if (tabPosName) {
                    document.querySelector('.' + tabPosName).click();
                }
            }
        });
    },

    // 根据设备获取修正值
    getFix: function () {

        // 这里是pc
        if ($('.navBox').length > 0) {
            var fix = 0;
            if (window.cateData.userRecordOption.title === 'eshop商城首页') {
                fix = 74;
            }
            return document.querySelector('.navBox').clientHeight + fix;
        }

        // 这里是wap
        if ($('.solution-topbar').length > 0) {
            return document.querySelector('.solution-topbar').clientHeight + document.querySelector('.module-nav-bar-fixed-st').clientHeight;
        }

        return 0;

    },

    init: function () {
        this.setPos();
    }
};

pos.init();
